import React from 'react';
import { SelectChangeEvent } from '@mui/material';
import Dropdown from '../Dropdown/Dropdown';

// Import services
import { getAllStates } from './services';

// Import Zustand store
import { useAppStore } from '../../stores';

interface Props {
  id: string;
  label: string;
  name: string;
  required?: boolean;
  onChange?: (event: SelectChangeEvent<string>) => void;
  displayDefaultValue?: boolean;
  defaultValue?: string;
}

interface StateItem {
  name?: string;
  value?: string;
  stateTerritoryCode?: string;
  stateTerritoryName?: string;
}

const StatePicker: React.FC<Props> = (props) => {
  // Zustand store
  const states = useAppStore((state) => state.stateReducer.states) as StateItem[];
  const setStates = useAppStore((state) => state.setStates);

  const formatStatesArray = (statesData: StateItem[]) => {
    const statesWithDefaultValue: StateItem[] = [{ name: 'All States', value: ' ' }];
    return statesWithDefaultValue.concat(statesData);
  };

  React.useEffect(() => {
    if (states.length === 0) {
      getAllStates().then((response: { data: StateItem[] }) => {
        setStates(formatStatesArray(response.data));
      });
    }
  }, [states.length, setStates]);

  return (
    <Dropdown
      id={props.id}
      label={props.label}
      selectedPropsValue={props.defaultValue}
      required={props.required ? props.required : false}
      values={states.map((state: StateItem, index: number) => {
        if (index === 0) {
          return <option key={index} value={''} />;
        }
        return (
          <option key={index} value={state.stateTerritoryCode}>
            {`${state.stateTerritoryCode} - ${state.stateTerritoryName}`}
          </option>
        );
      })}
      onChange={props.onChange ? props.onChange : undefined}
      name={props.name}
    />
  );
};

export default StatePicker;
